import styled from 'styled-components';

const StyledRequireProvideEmailDialogContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .title-container {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;

    .title {
      text-align: center;
      width: 100%;
    }
  }
`;

export { StyledRequireProvideEmailDialogContent };
